export const PPC_ACTION_TYPES = {
  GET_PPC_LIST_SUCCESS: 'GET_PPC_LIST_SUCCESS',
  ADD_CURRENT_PPC_STEP: 'ADD_CURRENT_PPC_STEP',
  GET_PPC_DETAIL: 'GET_PPC_DETAIL'
};
